import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const apiSmsNgRoutes = [
  {
    component: Loadable(lazy(() => import('../pages/api-sms-ng/Simple'))),
    path: PATH_DASHBOARD.api_sms_ng.simple.path,
    shouldRender: PATH_DASHBOARD.api_sms_ng.simple.renderCondition,
  },
];

export default apiSmsNgRoutes;

// test
